module.exports = __webpack_public_path__ + "static/players-383d030d96e94486c7aa00ab323d2c44.svg";